const ACTIVERESULTSTYPE = {
    SERIES: 'league',
    EVENT: 'competition',
};

export { ACTIVERESULTSTYPE };
